import Breadcrumbs, { BreadcrumbsProps } from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NextLink from 'atoms/NextLink';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import React from 'react';
import { INavItem } from 'utils/globalTypes';

interface IBreadcrumb {
  name: string;
  url: string;
  isActive?: boolean;
}

interface BreadcrumbsHeaderProps extends BreadcrumbsProps {
  navItems: INavItem[];
  isStatic?: boolean;
}

const BreadcrumbsHeader = ({ navItems, isStatic, ...rest }: BreadcrumbsHeaderProps) => {
  const router = useRouter();

  function getBreadcrumbs() {
    const path = router?.pathname?.split('/');
    const breadcrumbs: IBreadcrumb[] = [];
    const navItem = navItems?.find((item) => item.url?.split('?')[0] === `/${path[1]}`);
    if (navItem) {
      breadcrumbs.push({
        name: navItem.name,
        url: navItem.url,
        isActive: !navItem.menuItems
      });
      const menuItem = navItem.menuItems?.find(
        (item) => item.url?.split('?')[0] === router?.pathname
      );
      if (menuItem) {
        breadcrumbs.push({
          name: menuItem.name,
          url: menuItem.url,
          isActive: true
        });
      }
    } else {
      breadcrumbs.push({
        name: path[0].toUpperCase() + path[0].slice(1),
        url: router?.pathname,
        isActive: true
      });
    }
    return breadcrumbs;
  }

  const renderBreadcrumbs = (breadcrumbs: IBreadcrumb[]) => (
    <Breadcrumbs
      {...rest}
      sx={{ fontSize: '14px', pt: 0.5, pb: 0.5, width: '100%', ...rest.sx }}
      separator="›"
      aria-label="breadcrumb"
    >
      {breadcrumbs.map(({ name, url, isActive }) =>
        isActive || !url ? (
          <Typography key={name} color="text.primary" sx={{ fontSize: '14px', fontWeight: 600 }}>
            {name}
          </Typography>
        ) : (
          <NextLink key={name} href={url} passHref>
            <Link underline="hover" color="inherit">
              {name}
            </Link>
          </NextLink>
        )
      )}
    </Breadcrumbs>
  );

  return isStatic ? renderBreadcrumbs(navItems) : renderBreadcrumbs(getBreadcrumbs());
};

export default observer(BreadcrumbsHeader);
